import { Plus } from '@phosphor-icons/react';
import { DropdownMenu } from 'src/components/DropdownMenu';
export const VariablesDropdownMenu = ({
  isOpen,
  setIsOpen,
  promptVariables,
  handleVariableSelect,
  position = 'bottom-left',
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  promptVariables: string[];
  handleVariableSelect: (variable: string) => void;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
}) => {
  return (
    <DropdownMenu
      isOpen={isOpen}
      position={position}
      onItemClick={() => setIsOpen(false)}
      className="min-w-[250px] max-h-[300px] overflow-y-auto"
    >
      {promptVariables.map((variable) => (
        <li
          key={variable}
          className="px-3 py-2.5 hover:bg-neutral-50 cursor-pointer text-neutral-700 flex justify-between items-center"
          onClick={() => handleVariableSelect(variable)}
        >
          <span>{variable.replace('{', '').replace('}', '')}</span>
        </li>
      ))}

      <li
        className="px-3 py-2.5 hover:bg-neutral-50 cursor-pointer text-neutral-700 flex justify-between items-center"
        onClick={() => handleVariableSelect('{new_variable}')}
      >
        <span>Add new variable</span>
        <Plus size={20} />
      </li>
    </DropdownMenu>
  );
};
